import React, { ReactNode } from 'react';
import styled, { css, CSSProperties } from 'styled-components';
import { mq, Subtitle } from '@kvdbil/components';

interface Props {
  children: ReactNode;
  modifiers?: string[];
  heading?: string;
}

const isBleed = (modifiers: string[]) =>
  Array.isArray(modifiers) && modifiers.find(elem => elem === 'bleed');

const isDense = (modifiers: string[]) =>
  Array.isArray(modifiers) && modifiers.find(elem => elem === 'dense');

const variants = {
  default: css`
    max-width: 1024px;
  `,
  narrow: css`
    max-width: 540px;
  `,
  stretchHeight: css`
    height: 100%;
  `
};

export type Variant = keyof typeof variants;

const WellContainer = styled.div<WellProps>`
  background: ${({ theme }) => theme.colors.background.light};
  box-shadow: ${({ theme, boxShadow }) =>
    boxShadow ? theme.elevations.elevation2 : 'none'};

  margin: 0 auto;
  position: relative;
  padding: ${({ modifiers = [] }: Props) => (isBleed(modifiers) ? 4 : 1.25)}rem;
  width: 100%;

  ${mq(null, 'mobileL')} {
    padding: ${({ modifiers = [] }: Props) =>
      isDense(modifiers) ? 0.75 : 1.5}rem;
  }

  text-align: ${({ textAlign = 'left' }) => textAlign};
  ${({ variant }) => variants[variant ?? 'default']};
`;

const WellHeading = styled(Subtitle)`
  font-weight: 500;
`;

interface WellProps {
  textAlign?: CSSProperties['textAlign'];
  variant?: Variant;
  heading?: string;
  modifiers?: string[];
  children: ReactNode;
  boxShadow?: boolean;
}
export default function Well({
  children,
  heading = '',
  variant = 'default',
  boxShadow = true,
  ...props
}: WellProps) {
  return (
    <WellContainer {...props} boxShadow={boxShadow} variant={variant}>
      {heading ? <WellHeading as="h3">{heading}</WellHeading> : null}
      <div>{children}</div>
    </WellContainer>
  );
}
